import {
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "../../config/axiosConfig";

export const getAllEmployee = async ({
  appliedSearch = "",
  role_id,
  hospital_branch_id,
  page,
  limit,
  role,
} = {}) => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "management/get-all-employee",
      params: {
        search: appliedSearch || undefined,
        hospital_branch_id: hospital_branch_id || undefined,
        role_id: role_id || undefined,
        page: page || undefined,
        limit: limit || undefined,
        role: role || undefined,
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};

export const getEmployeeById = async ({ id }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "management/get-employee-by-id",
      data: {
        id,
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};

export const changeEmployeeStatus = async ({ id, isActive }) => {
  try {
    const response = await patchRequest({
      url: process.env.REACT_APP_BASE_URL + "management/toggle-employee-status",
      data: {
        employee_id: id,
        is_active: isActive
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};



export const updateDoctor = async ({ id , payload}) => {
  try {
    const response = await putRequest({
      url: process.env.REACT_APP_BASE_URL + `doctors/${id}`,
      data: payload
    });

         if (response?.success || response?.status === 200 || response?.status?.code === 201 || response?.status?.code === 200) {

      return {
        success: response?.success || response?.status === 200 || response?.status?.code === 201 || response?.status?.code === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Failed to update doctor.",
    };
  }
};